import { ToastRegion } from "@imi/ui/components/Toast/Toast.js";
import { useCallback, useMemo, useState } from "react";
import { Toast } from "./Toast";
import { ToastContext, ToastMessage } from "./ToastContext";

interface IToastContextProviderProps {
  children: React.ReactNode;
}

export function ToastContextProvider({ children }: IToastContextProviderProps) {
  const [toasts, setToasts] = useState<({ id: string } & ToastMessage)[]>([]);

  const addToast = useCallback((toast: ToastMessage) => {
    setToasts((prevToasts) => [
      ...prevToasts,
      { ...toast, id: crypto.randomUUID() },
    ]);
  }, []);

  const removeToast = useCallback((id: string) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  }, []);

  const context = useMemo(
    () => ({ addToast, removeToast, toasts }),
    [addToast, removeToast, toasts],
  );

  return (
    <ToastContext.Provider value={context}>
      {children}
      {!!toasts.length && (
        <ToastRegion>
          {toasts.map((toast) => (
            <Toast
              key={toast.id}
              removeToast={() => removeToast(toast.id)}
              {...toast}
            />
          ))}
        </ToastRegion>
      )}
    </ToastContext.Provider>
  );
}
